module.exports = __webpack_public_path__ + "lastSlideLeft.png?73dd27f4fba8f25048c5f3c87fc70f2a";